import TextAndImageSection from "../../componets/TextAndImageSection";

export default function Section6() {
  return (
    <TextAndImageSection
      sectionName="Section6"
      containerName="section6"
      title="Elevate Your Brand with Exceptional Design"
      text="Ready to take your products and merchandise to the next level? Let's collaborate on a design that leaves a lasting impact. Reach out to us today to discuss your project and learn how our design services can enhance your brand's visual identity."
      imgUrl="assets/mobile-logo-and-branding.png"
      dividerMargin=" mt-[1%] md:mt-[5%]"
      btnLink="https://mean3.com/contact-mean3/"
    />
  );
}
